import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import  org from './slices/orgSlice'
import  roleBuilder from './slices/roleBuilder'
import stages from './slices/stageSlice'
import questions from './slices/questionSlice'
import accessReducer from './slices/AccessSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        org,
        roleBuilder,
        stages,
        questions,
        access: accessReducer,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
